import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-dialog',
  templateUrl: './customer-dialog.component.html',
  styleUrls: ['./customer-dialog.component.scss']
})
export class CustomerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public customerData: any
  ) {}

  onSelect(customer) {
    let updatedValue = {...customer}
    if(customer.drvaFlag){
      updatedValue = {
          ...customer,
          emailAddress : "",
          phoneNumber: ""
        }
    }
    this.dialogRef.close(updatedValue);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
